import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {HubCorporateService} from "../../shared/services/hub-corporate.service";
import {takeUntil} from "rxjs/operators";
import {Corporate} from "../../shared/types/corporate";
import {NotificationService} from "../../shared/services/notification.service";
import {HelpersService} from "../../shared/services/helpers.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-corporate-modal',
  templateUrl: './delete-corporate-modal.component.html',
  styleUrls: ['./delete-corporate-modal.component.scss']
})
export class DeleteCorporateModalComponent implements OnInit {

  @Input() corporate: Corporate;
  @Input() isRedirectionNeeded = false;
  @Output() emitClose = new EventEmitter();
  @Output() emitDismiss = new EventEmitter();
  @Output() emitDeleteCorporate = new EventEmitter<boolean>();

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private hubCorporateService: HubCorporateService,
              private _notificationSvc: NotificationService,
              private helpers: HelpersService,
              private translate: TranslateService) { }

  ngOnInit(): void {
  }

  delete() {
    this.hubCorporateService.delete(this.corporate.id)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((response: any) => {
        const res = response.body;
        if (res.status === 'OK') {
          if (this.isRedirectionNeeded) {
            this.helpers.go('/corporates');
          }
          this._notificationSvc.clearNotifications();
          this._notificationSvc.success(
            this.translate.instant('NOTIFICATIONS.SUCCESS'),
            this.translate.instant('DELETE_CORPORATE_MODAL.NOTIFICATIONS.CORPORATE_DELETED'),
            0);
          this.emitDeleteCorporate.emit(true);
          this.emitClose.emit();
        }
      });
  }
}
